import { Actor, Vector, Color, Engine, CollisionType } from 'excalibur';

export class Shell extends Actor {
    onInitialize() {
        this.on('collisionstart', (evt) => {
            const other = evt.other;
            // Only kill mortars, not terrain or other shells
            if (other instanceof Actor && other.constructor && other.constructor.name === 'Mortar') {
                // Remove both the shell and the mortar
                this.kill();
                other.kill();
            }
        });
    }
    public velocity: Vector;
    public hasCollided: boolean = false;

    constructor(x: number, y: number, velocity: Vector, color: Color) {
        // Use a highly visible color for debugging
        super({ x, y, width: 12, height: 12, color: Color.Yellow });
        this.body.collisionType = CollisionType.Active;
        this.collider.useCircleCollider(6); // radius = 6 (half width)
        this.velocity = velocity;
        console.log('[Shell] Spawned at', { x, y, velocity });
    }

    onPreUpdate(engine: Engine, delta: number) {
        if (!this.hasCollided) {
            this.vel = this.velocity;
            this.velocity = this.velocity.add(new Vector(0, 500 * (delta / 1000))); // gravity
        }
    }

    checkOffScreen(engine: Engine) {
        return this.pos.y > engine.drawHeight;
    }
}
